<script>
import axios from '@/utils/axios';
import {clientAdmin, logoutUser} from '@/utils/auth';
import { useToast } from 'vue-toastification';
import sideBarData from "@/assets/json/sidebar-menuone.json";
import NotificationBell from '@/components/NotificationBell.vue'

export default {
inject: ['setLoading'],
components: {
 NotificationBell 
},
data() {
 return {
  toast: useToast(),
  //notificationClass: "pe-1",
  openMenuItem: null,
  sideBarData: sideBarData,
  openSubmenuOneItem: null,
  route_array: [],
  errors: {},
 };
},

computed: {
 logo() {
  if(this.clientAdmin?.company?.logo){
   return this.clientAdmin.company.logo_url;
  }
  return require('@/assets/img/logo.webp');
 }
},

mounted() { 
 this.initMouseoverListener();
 //this.handleOutsideClick = this.handleOutsideClick.bind(this);
   this.$router.afterEach(() => {
    document.body.classList.remove("slide-nav");
  });

},


methods: {

 //LOGOUT USER
 async logout(){
  this.errors = {};
  this.setLoading(true);
  try{
   const response = await axios.post('/logout', {});
   logoutUser();
   // Reset notification state on logout
   this.$resetNotificationState();

   this.$router.push('/');
  }catch(error){
   if(error.type === 'validation'){
    this.errors = error.errors;
   }else{
    this.toast.error(error.message);
   }
  }finally{
   this.setLoading(false);
  }
 }, 

//  handleClick(event) {
//  event.stopPropagation();

//  if (this.notificationClass === "pe-1 notification-item-show") {
//  // If the class is already present, remove it
//   this.notificationClass = "";
//   document.removeEventListener("click", this.handleOutsideClick);
//  } else {
//   // If the class is not present, add it
//   this.notificationClass = "pe-1 notification-item-show";
//   document.addEventListener("click", this.handleOutsideClick);
//  }
//  },
//  handleOutsideClick(event) {
//   // Check if the click was outside the notification item
//   const notificationItem = event.target.closest(".notification-item");
//   if (!notificationItem) {
//   this.notificationClass = "";
//   // Remove the event listener
//   document.removeEventListener("click", this.handleOutsideClick);
//  }
//  },

 toggleSidebar1() {
  const body = document.body;
  body.classList.toggle("slide-nav");
 },
 toggleSidebar() {
  const body = document.body;
  body.classList.toggle("mini-sidebar");
 },

 initFullScreen() {
  document.body.classList.toggle("fullscreen-enable");
  if (!document.fullscreenElement && !document.mozFullScreenElement && !document.webkitFullscreenElement) {
  // current working methods
  if (document.documentElement.requestFullscreen) {
  document.documentElement.requestFullscreen();
  } else if (document.documentElement.mozRequestFullScreen) {
  document.documentElement.mozRequestFullScreen();
  } else if (document.documentElement.webkitRequestFullscreen) {
  document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
  }
  } else {
  if (document.cancelFullScreen) {
  document.cancelFullScreen();
  } else if (document.mozCancelFullScreen) {
  document.mozCancelFullScreen();
  } else if (document.webkitCancelFullScreen) {
  document.webkitCancelFullScreen();
  }
 }
},

initMouseoverListener() {
document.addEventListener("mouseover", this.handleMouseover);
},
handleMouseover(e) {
e.stopPropagation();

const body = document.body;
const toggleBtn = document.getElementById("toggle_btn");

if (body.classList.contains("mini-sidebar") && this.isElementVisible(toggleBtn)) {
const target = e.target.closest(".sidebar, .header-left");

if (target) {
body.classList.add("expand-menu");
this.slideDownSubmenu();
} else {
body.classList.remove("expand-menu");
this.slideUpSubmenu();
}

e.preventDefault();
}
},
isElementVisible(element) {
return element.offsetWidth > 0 || element.offsetHeight > 0;
},
slideDownSubmenu() {
const subdropPlusUl = document.getElementsByClassName("subdrop");
for (let i = 0; i < subdropPlusUl.length; i++) {
const submenu = subdropPlusUl[i].nextElementSibling;
if (submenu && submenu.tagName.toLowerCase() === "ul") {
submenu.style.display = "block";
}
}
},
slideUpSubmenu() {
const subdropPlusUl = document.getElementsByClassName("subdrop");
for (let i = 0; i < subdropPlusUl.length; i++) {
const submenu = subdropPlusUl[i].nextElementSibling;
if (submenu && submenu.tagName.toLowerCase() === "ul") {
submenu.style.display = "none";
}
}
},
expandSubMenus(menu) {
this.sideBarData.forEach((item) => {
item.menu.forEach((subMenu) => {
if (subMenu !== menu) {
subMenu.showSubRoute = false;
}
});
});
menu.showSubRoute = !menu.showSubRoute;
},
openMenu(menu) {
this.openMenuItem = this.openMenuItem === menu ? null : menu;
},
openSubmenuOne(subMenus) {
this.openSubmenuOneItem = this.openSubmenuOneItem === subMenus ? null : subMenus;
},
},
beforeUnmount() {
 document.removeEventListener("mouseover", this.handleMouseover);
 //document.removeEventListener("click", this.handleOutsideClick);
},
};
</script>

<template>
<div class="header">
<div class="main-header">
<div class="header-left">
<router-link to="/dashboard/" class="logo">
<img :src="logo" alt="Logo" width="100" />
</router-link>
<router-link to="/dashboard/" class="dark-logo">
<img :src="logo" alt="Logo" width="100" />
</router-link>
</div>
 
<a id="mobile_btn" class="mobile_btn" @click="toggleSidebar1" href="javascript:void(0);">
<span class="bar-icon">
<span></span>
<span></span>
<span></span>
</span>
</a>
 
<div class="header-user">
<div class="nav user-menu nav-list">
<div class="me-auto d-flex align-items-center" id="header-search">
<a id="toggle_btn" href="javascript:void(0);" @click="toggleSidebar" class="btn btn-menubar me-2">
<i class="ti ti-arrow-bar-to-left"></i>
</a>
<!-- Search -->
 <h4 class="me-3">{{ clientAdmin?.company?.company_name }}</h4>
<!-- <div class="input-group input-group-flat d-inline-flex me-1">
<span class="input-icon-addon">
<i class="ti ti-search"></i>
</span>
<input type="text" class="form-control" placeholder="Search" disabled />
<span class="input-group-text">
<kbd>CTRL + / </kbd>
</span>
</div> -->
<!-- /Search -->
 
<router-link to="/app-settings/app-store" class="btn btn-menubar">
 <i class="ti ti-settings-cog"></i>
</router-link>
 
</div>
 
<!-- Horizontal Single -->
<!-- <div class="sidebar sidebar-horizontal" id="horizontal-single">
<div class="sidebar-menu">
<div class="main-menu">
<ul class="nav-menu">
<template v-for="item in sideBarData" :key="item.tittle">
<li class="menu-title">
<span>{{ item.tittle }}</span>
</li>
<template v-for="menu in item.menu" :key="menu.menuValue">
<li v-if="!menu.hasSubRoute && menu.menuValue === 'Application'">
  <router-link :to="menu.route">
    <i :class="'ti ti-' + menu.icon"></i>
    <span>{{ menu.menuValue }}</span>
  </router-link>
</li>
<li
  class="submenu"
  v-else-if="
    menu.hasSubRoute &&
    (menu.menuValue === 'Dashboard' ||
      menu.menuValue === 'Applications' ||
      menu.menuValue === 'Super Admin' ||
      menu.menuValue === 'Layouts')
  "
  @click="expandSubMenus(menu)"
>
  <a
    href="javascript:void(0)"
    :class="{ subdrop: menu.showSubRoute }"
  >
    <i :class="'ti ti-' + menu.icon"></i>
    <span>{{ menu.menuValue }}</span>
    <span class="menu-arrow"></span>
  </a>
  <ul
    :class="{
      'd-block': menu.showSubRoute,
      'd-none': !menu.showSubRoute,
    }"
  >
    <template
      v-for="subMenu in menu.subMenus"
      :key="subMenu.menuValue"
    >
      <li>
        <router-link :to="subMenu.route">{{
          subMenu.menuValue
        }}</router-link>
      </li>
    </template>
  </ul>
</li>
<li v-if="menu.hasSubRouteTwo" class="submenu">
  <a
    href="javascript:void(0);"
    @click="openMenu(menu)"
    :class="{
      subdrop: openMenuItem === menu,
      active: route_array[0] === menu.active_link,
    }"
  >
    <i :class="'ti ti-' + menu.icon"></i
    ><span>{{ menu.menuValue }}</span>
    <span class="menu-arrow"></span>
  </a>
  <ul
    :class="{
      'd-block': openMenuItem === menu,
      'd-none': openMenuItem !== menu,
    }"
  >
    <li
      v-for="subMenus in menu.subMenus"
      :key="subMenus.menuValue"
      :class="{
        'submenu submenu-two':
          subMenus.menuValue === 'Calls' ||
          subMenus.menuValue === 'Projects' ||
          subMenus.menuValue === 'Crm' ||
          subMenus.menuValue === 'Employee' ||
          subMenus.menuValue === 'Tickets' ||
          subMenus.menuValue === 'Attendance' ||
          subMenus.menuValue === 'Performance' ||
          subMenus.menuValue === 'Training' ||
          subMenus.menuValue === 'Requirment' ||
          subMenus.menuValue === 'Sales' ||
          subMenus.menuValue === 'Accounting' ||
          subMenus.menuValue === 'Payroll' ||
          subMenus.menuValue === 'Assets' ||
          subMenus.menuValue === 'Help & Supports' ||
          subMenus.menuValue === 'User Management' ||
          subMenus.menuValue === 'Reports' ||
          subMenus.menuValue === 'General Settings' ||
          subMenus.menuValue === 'Website Settings' ||
          subMenus.menuValue === 'App Settings' ||
          subMenus.menuValue === 'System Settings' ||
          subMenus.menuValue === 'Financial Settings' ||
          subMenus.menuValue === 'Other Settings' ||
          subMenus.menuValue === 'Blogs' ||
          subMenus.menuValue === 'Locations' ||
          subMenus.menuValue === 'Login' ||
          subMenus.menuValue === 'Register' ||
          subMenus.menuValue === 'Forgot Password' ||
          subMenus.menuValue === 'Reset Password' ||
          subMenus.menuValue === 'Email Verification' ||
          subMenus.menuValue === '2 Step Verification' ||
          subMenus.menuValue === 'Base UI' ||
          subMenus.menuValue === 'Advanced UI' ||
          subMenus.menuValue === 'Forms' ||
          subMenus.menuValue === 'Tables' ||
          subMenus.menuValue === 'Charts' ||
          subMenus.menuValue === 'Icons',
      }"
    >
      <template v-if="!subMenus.customSubmenuTwo">
        <router-link :to="subMenus.route">{{
          subMenus.menuValue
        }}</router-link>
      </template>
      <template v-else-if="subMenus.customSubmenuTwo">
        <a
          href="javascript:void(0);"
          @click="openSubmenuOne(subMenus)"
          :class="{ subdrop: openSubmenuOneItem === subMenus }"
          >{{ subMenus.menuValue
          }}<span class="menu-arrow inside-submenu"></span
        ></a>
        <ul
          :class="{
            'd-block': openSubmenuOneItem === subMenus,
            'd-none': openSubmenuOneItem !== subMenus,
          }"
        >
          <li
            v-for="subMenuTwo in subMenus.subMenusTwo"
            :key="subMenuTwo.menuValue"
          >
            <router-link :to="subMenuTwo.route">{{
              subMenuTwo.menuValue
            }}</router-link>
          </li>
        </ul>
      </template>
    </li>
  </ul>
</li>
</template>
</template>
</ul>
</div>
</div>
</div> -->
<!-- /Horizontal Single -->
 
<div class="d-flex align-items-center">
<div class="me-1">
<a href="javascript:void(0);" class="btn btn-menubar btnFullscreen" @click="initFullScreen">
<i class="ti ti-maximize"></i>
</a>
</div>
 
<!-- <div class="dropdown me-1">
<a href="javascript:void(0);" class="btn btn-menubar" data-bs-toggle="dropdown">
<i class="ti ti-layout-grid-remove"></i>
</a>
<div class="dropdown-menu dropdown-menu-end">
<div class="card mb-0 border-0 shadow-none">
<div class="card-header">
  <h4>Applications</h4>
</div>
<div class="card-body">
  <router-link to="/applications/events" class="d-block pb-2">
    <span class="avatar avatar-md bg-transparent-dark me-2"
      ><i class="ti ti-calendar text-gray-9"></i></span
    >Calendar
  </router-link>
  <router-link to="/applications/todo" class="d-block py-2">
    <span class="avatar avatar-md bg-transparent-dark me-2"
      ><i class="ti ti-subtask text-gray-9"></i></span
    >To Do
  </router-link>
  <router-link to="/applications/notes" class="d-block py-2">
    <span class="avatar avatar-md bg-transparent-dark me-2"
      ><i class="ti ti-notes text-gray-9"></i></span
    >Notes
  </router-link>
  <router-link to="/applications/file-manager" class="d-block py-2">
    <span class="avatar avatar-md bg-transparent-dark me-2"
      ><i class="ti ti-folder text-gray-9"></i></span
    >File Manager
  </router-link>
  <router-link to="/applications/kanban-view" class="d-block py-2">
    <span class="avatar avatar-md bg-transparent-dark me-2"
      ><i class="ti ti-layout-kanban text-gray-9"></i></span
    >Kanban
  </router-link>
  <router-link to="/applications/invoices" class="d-block py-2 pb-0">
    <span class="avatar avatar-md bg-transparent-dark me-2"
      ><i class="ti ti-file-invoice text-gray-9"></i></span
    >Invoices
  </router-link>
</div>
</div>
</div>
</div> -->
 
<!-- <div class="me-1">
 <router-link to="#" class="btn btn-menubar position-relative">
  <i class="ti ti-brand-hipchat"></i>
  <span class="badge bg-info rounded-pill d-flex align-items-center justify-content-center header-badge">0</span>
 </router-link>
</div>
 
<div class="me-1">
 <router-link to="#" class="btn btn-menubar">
  <i class="ti ti-mail"></i>
 </router-link>
</div> -->
 
<div class="me-1">
 <NotificationBell />
</div>
 
<!-- <div class="me-1 notification_item">
 <a href="javascript:void(0);" class="btn btn-menubar position-relative me-1" id="notification_popup" data-bs-toggle="dropdown">
<i class="ti ti-bell"></i>
<span class="notification-status-dot"></span>
</a>
<div class="dropdown-menu dropdown-menu-end notification-dropdown p-4">
<div class="d-flex align-items-center justify-content-between border-bottom p-0 pb-3 mb-3">
<h4 class="notification-title">Notifications (0)</h4>
<div class="d-flex align-items-center">
  <a href="javascript:void(0);" class="text-primary fs-15 me-3 lh-1">Mark all as read</a>
</div>
</div>
<div class="noti-content">
<div class="d-flex flex-column">
   
 <div class="border-0 mb-3 pb-0">
<router-link to="/crm/activity">
<div class="d-flex">
<span class="avatar avatar-lg me-2 flex-shrink-0">
 <img src="@/assets/img/profiles/avatar-01.jpg" alt="Profile"/>
</span>
<div class="flex-grow-1">
  <p class="mb-1">
    A new teacher record for
    <span class="text-dark fw-semibold">Elisa</span>
  </p>
  <span>09:45 AM</span>
</div>
</div>
</router-link>
</div> 
 
</div>
</div>
<div class="d-flex p-0">
<a href="javascript:void(0);" class="btn btn-light w-100 me-2">Cancel</a>
<router-link to="#" class="btn btn-primary w-100">View All</router-link>
</div>
</div>
</div> -->
 
<!-- ===== UPDATED PROFILE DROPDOWN ===== -->
<div class="dropdown profile-dropdown ms-1">
  <a href="javascript:void(0);" class="profile-trigger d-flex align-items-center gap-2" data-bs-toggle="dropdown" data-bs-auto-close="outside">
    <span class="avatar avatar-sm online">
      <img :src="auth?.image ? auth?.image_url : require('@/assets/img/profiles/avatar-02.jpg')" 
  alt="Img" class="img-fluid rounded-circle"/>
    </span>
    <div class="profile-trigger-info d-none d-md-block">
      <span class="profile-trigger-name">{{ auth?.name }}</span>
      <span class="profile-trigger-role">{{ auth?.role?.name }}</span>
    </div>
    <i class="ti ti-chevron-down profile-trigger-chevron d-none d-md-block"></i>
  </a>
 
  <div class="dropdown-menu dropdown-menu-end profile-dropdown-menu shadow">
    <!-- User Info Header -->
    <div class="profile-dropdown-header">
      <span class="avatar avatar-md avatar-rounded flex-shrink-0">
        <img :src="auth?.image ? auth?.image_url : require('@/assets/img/profiles/avatar-02.jpg')" 
  alt="img" />

      </span>
      <div class="profile-dropdown-header-info">
        <h6 class="mb-0">{{ auth?.name }}</h6>
        <p class="fs-12 fw-medium mb-0 text-muted">{{ auth?.role?.name }}</p>
        <div v-if="auth?.branch !== null" class="mt-1">
          <span class="profile-branch-badge">
            {{ auth?.branch?.name }}<span v-if="auth?.branch?.code"> ({{ auth?.branch?.code }})</span>
          </span>
        </div>
      </div>
    </div>
 
    <div class="profile-dropdown-divider"></div>
 
    <!-- Menu Items -->
    <div class="profile-dropdown-body">
      <router-link class="profile-dropdown-item" to="/profile">
        <span class="profile-dropdown-item-icon"><i class="ti ti-user-circle"></i></span>
        <span>My Profile</span>
      </router-link>
 
      <a v-if="auth" class="profile-dropdown-item" data-bs-toggle="modal" data-bs-target="#activityLogModal"
        @click="$refs.activityModal.activityLogs(), $refs.activityModal.initActivityDatePicker();">
        <span class="profile-dropdown-item-icon"><i class="ti ti-activity"></i></span>
        <span>Activity Log</span>
      </a>
 
      <a v-if="auth" class="profile-dropdown-item" data-bs-toggle="modal" data-bs-target="#loginHistoryModal"
        @click="$refs.activityModal.loginHistory(), $refs.activityModal.initLoginDatePicker();">
        <span class="profile-dropdown-item-icon"><i class="ti ti-history"></i></span>
        <span>Login History</span>
      </a>
 
      <router-link v-if="auth && auth.type === 'ADMIN'" class="profile-dropdown-item" to="/general-settings/business-settings">
        <span class="profile-dropdown-item-icon"><i class="ti ti-settings"></i></span>
        <span>Settings</span>
      </router-link>
    </div>
 
    <div class="profile-dropdown-divider"></div>
 
    <!-- Logout -->
    <div class="profile-dropdown-footer">
      <a class="profile-dropdown-item profile-dropdown-logout" href="javascript:void(0);" @click="logout">
        <span class="profile-dropdown-item-icon"><i class="ti ti-logout"></i></span>
        <span>Sign Out</span>
      </a>
    </div>
  </div>
</div>
<!-- ===== END PROFILE DROPDOWN ===== -->
 
</div>
</div>
</div>
 
<!-- Mobile Menu -->
<div class="dropdown mobile-user-menu">
  <a href="javascript:void(0);" class="mobile-dots-trigger" data-bs-toggle="dropdown" aria-expanded="false">
    <i class="fa fa-ellipsis-v"></i>
  </a>
  <div class="dropdown-menu dropdown-menu-end mobile-grid-dropdown shadow">
    <!-- Icon Grid -->
    <div class="mobile-grid-body">
      <router-link class="mobile-grid-item" to="/profile">
        <span class="mobile-grid-icon"><i class="ti ti-user-circle"></i></span>
        <span class="mobile-grid-label">Profile</span>
      </router-link>
 
      <a v-if="auth" class="mobile-grid-item" data-bs-toggle="modal" data-bs-target="#activityLogModal"
        @click="$refs.activityModal.activityLogs();">
        <span class="mobile-grid-icon"><i class="ti ti-activity"></i></span>
        <span class="mobile-grid-label">Activity</span>
      </a>
 
      <a v-if="auth" class="mobile-grid-item" data-bs-toggle="modal" data-bs-target="#loginHistoryModal"
        @click="$refs.activityModal.loginHistory();">
        <span class="mobile-grid-icon"><i class="ti ti-history"></i></span>
        <span class="mobile-grid-label">History</span>
      </a>
 
      <router-link v-if="auth && auth.type === 'ADMIN'" class="mobile-grid-item" to="/general-settings/business-settings">
        <span class="mobile-grid-icon"><i class="ti ti-settings"></i></span>
        <span class="mobile-grid-label">Settings</span>
      </router-link>
    </div>
 
    <div class="profile-dropdown-divider"></div>
 
    <!-- Sign Out -->
    <div class="mobile-grid-footer">
      <a class="mobile-grid-signout" href="javascript:void(0);" @click="logout">
        <i class="ti ti-logout"></i>
        <span>Sign Out</span>
      </a>
    </div>
  </div>
</div>
<!-- /Mobile Menu -->
</div>
 
</div>
 
<activity-modal ref="activityModal"></activity-modal>
 
</template>
 
<style scoped>
/* ===== MOBILE DOTS TRIGGER ===== */
.mobile-dots-trigger {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  color: #374151;
  font-size: 16px;
  text-decoration: none;
  transition: background 0.15s ease;
}
.mobile-dots-trigger:hover {
  background: rgba(0, 0, 0, 0.05);
  color: #111827;
}
 
/* ===== MOBILE GRID DROPDOWN ===== */
.mobile-grid-dropdown {
  min-width: 200px;
  padding: 0;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  margin-top: 8px !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.10) !important;
  background: #ffffff;
}
 
/* ===== MOBILE GRID BODY ===== */
.mobile-grid-body {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
  padding: 12px 10px;
}
 
/* ===== MOBILE GRID ITEM ===== */
.mobile-grid-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 6px;
  border-radius: 10px;
  text-decoration: none;
  color: #374151;
  transition: background 0.12s ease, color 0.12s ease;
  cursor: pointer;
}
.mobile-grid-item:hover {
  background: #f3f4f6;
  color: #111827;
}
.mobile-grid-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 18px;
  transition: background 0.12s ease, color 0.12s ease;
}
.mobile-grid-item:hover .mobile-grid-icon {
  background: #e5e7eb;
  color: #374151;
}
.mobile-grid-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  color: #6b7280;
}
.mobile-grid-item:hover .mobile-grid-label {
  color: #374151;
}
.header .mobile-user-menu a{
  margin-top: 8px;
}
 
/* ===== MOBILE SIGN OUT ===== */
.mobile-grid-footer {
  padding: 8px 10px;
}
.mobile-grid-signout {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 10px;
  border-radius: 8px;
  text-decoration: none;
  color: #ef4444;
  font-size: 13.5px;
  font-weight: 600;
  width: 100%;
  transition: background 0.12s ease;
  cursor: pointer;
}
.mobile-grid-signout:hover {
  background: #fef2f2;
  color: #dc2626;
}
.mobile-grid-signout i {
  font-size: 16px;
}
 
/* ===== PROFILE TRIGGER BUTTON ===== */
.profile-trigger {
  text-decoration: none;
  padding: 5px 10px;
  border-radius: 8px;
  transition: background 0.15s ease;
  cursor: pointer;
}
.profile-trigger:hover {
  background: rgba(0, 0, 0, 0.04);
}
.profile-trigger-info {
  line-height: 1.2;
}
.profile-trigger-name {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #1a1a2e;
}
.profile-trigger-role {
  display: block;
  font-size: 11px;
  color: #6b7280;
}
.profile-trigger-chevron {
  font-size: 14px;
  color: #9ca3af;
  transition: transform 0.2s ease;
}
.profile-dropdown.show .profile-trigger-chevron {
  transform: rotate(180deg);
}
 
/* ===== DROPDOWN MENU ===== */
.profile-dropdown-menu {
  min-width: 240px;
  padding: 0;
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  margin-top: 8px !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.10) !important;
  background: #ffffff;
}
 
/* ===== HEADER SECTION ===== */
.profile-dropdown-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
  background: #fafafa;
}
.profile-dropdown-header-info h6 {
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}
.profile-branch-badge {
  display: inline-block;
  font-size: 10px;
  padding: 2px 8px;
  background: #eff6ff;
  color: #3b82f6;
  border-radius: 20px;
  border: 1px solid #bfdbfe;
  font-weight: 500;
}
 
/* ===== DIVIDER ===== */
.profile-dropdown-divider {
  height: 1px;
  background: #f3f4f6;
  margin: 0;
}
 
/* ===== MENU BODY ===== */
.profile-dropdown-body {
  padding: 6px 8px;
}
.profile-dropdown-footer {
  padding: 6px 8px;
}
 
/* ===== MENU ITEMS ===== */
.profile-dropdown-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 10px;
  border-radius: 8px;
  text-decoration: none;
  color: #374151;
  font-size: 13.5px;
  font-weight: 500;
  transition: background 0.12s ease, color 0.12s ease;
  cursor: pointer;
}
.profile-dropdown-item:hover {
  background: #f3f4f6;
  color: #111827;
}
.profile-dropdown-item-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 7px;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 15px;
  flex-shrink: 0;
  transition: background 0.12s ease, color 0.12s ease;
}
.profile-dropdown-item:hover .profile-dropdown-item-icon {
  background: #e5e7eb;
  color: #374151;
}
 
/* ===== LOGOUT ITEM ===== */
.profile-dropdown-logout {
  color: #ef4444;
}
.profile-dropdown-logout:hover {
  background: #fef2f2;
  color: #dc2626;
}
.profile-dropdown-logout .profile-dropdown-item-icon {
  background: #fef2f2;
  color: #ef4444;
}
.profile-dropdown-logout:hover .profile-dropdown-item-icon {
  background: #fee2e2;
  color: #dc2626;
}

@media (max-width: 991.98px) {
    .header .header-left .logo img {
        width: 56px !important;
    }
}
</style>
